import { render } from "./DashobardFinanceSectionMyProfile.vue?vue&type=template&id=4fee770a"
import script from "./DashobardFinanceSectionMyProfile.vue?vue&type=script&lang=js"
export * from "./DashobardFinanceSectionMyProfile.vue?vue&type=script&lang=js"

import "./DashobardFinanceSectionMyProfile.vue?vue&type=style&index=0&id=4fee770a&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__